import './iscroll.js';
import './horizontal_tabs';

import setPreview from './_video-preview.js';

//functions
import InfiniteSliderCreator from './infinite-slider-creator/index.js';
import videoPlaysInline from './video-plays-inline/index.js';

//components
import videoLoop from './video-loop/index.js';

// screens
import TankRotationScreen from './index.js';


export function init_tank_rotation_screen() {
	'use strict';

	var $documentRoots = $('html, body'),
		$scrollToButton = $('.js-info-scroll-to-second-slide'),
		$scrollTo = $('.js-scroll-to'),
		$animItem = $('.js-release-block-anim'),
		animItemClass = $animItem.data('activeClass'),
		bottomIndent = 0,
		isElemHidden = true,
		windowHeightIndentDiff = getWindowHeightIndentDiff(),

		boysIcoClass = '.boys-slider_pin',
		boysIcoShadowClass = 'boys-slider_pin__shadow',
		sliderArrowClass = '.w-slider-arrows_item',
		boysIcoViewedClass = 'boys-slider_pin__viewed',
		sliderHighlightClass = '.boys-slider_h-img',
		sliderHighlightActiveClass = 'boys-slider_h-img__active',
		$bigDescr = $('.release-wrapper').find('.js-big-descr'),
		$minDescr = $('.release-wrapper').find('.js-min-descr');

	$('.js-boys-slider').each(function() {
		let wrapper; // строка с классом оберткой слайдера
		new InfiniteSliderCreator(this, wrapper);
	});

	$('.release-block_video-wrapp').each(function() {
		new videoLoop(this);
	});

	new HorizontalTabs({container: '.js-horizontal-tabs-429051'});
	addOverlay();
	setFirstShadow();
	setPreview();
	videoPlaysInline(); // bugfix looped video autoplay on iOS devices

	new TankRotationScreen('.js-tank-rotation-screen');


	$('body').on('click', sliderArrowClass, () => { setTimeout(() => setFirstShadow(), 1560); });    
	$('body').on('mouseenter mouseleave', boysIcoClass,  (e) => { controlIcoShadow(e); showHiglight(e);}); 
	$('.r-tanks_item').on('mouseenter click', () => {

		$('.r-tanks_dot').remove();
	});
	$('body').on('click', boysIcoClass, (e) => {
		if (window.innerWidth <= 800) {
			getText(e);
			showTooltip(e);
		}
        
	});
	$('.release-wrapper').on('click', '.map-popup', () => {
		if (window.innerWidth <= 800 && $('.map-popup').hasClass('map-popup__show')) {
			closeTooltip();
		}                
	});

	$(window).on('load resize', _.throttle(() => {
		if (window.innerWidth >= 800) {
			controlHeightDescr();
		}  
	}, 400));

	function getText(e) {
		let $currEl = $(e.currentTarget),
			title = $currEl.find('.boys-slider-tooltip_title').clone(),
			text = $currEl.find('.boys-slider-tooltip_text').clone();

		$('.release-wrapper').find('.map-popup_wrapper').append(title).append(text);
	}
	function showTooltip(e) {
		let $currEl = $(e.currentTarget);
		$('body').css('top', -$(window).scrollTop());

		$('.release-wrapper').find('.map-popup').addClass('map-popup__show');
		$('body, html').addClass('global-crop');
	}
	function closeTooltip() {
		var pageWrapper = $('body');
		var offsetTop = pageWrapper.offset().top;
		pageWrapper.css('top', '');
		$('.release-wrapper').find('.map-popup').removeClass('map-popup__show');
		$('body, html').removeClass('global-crop');
		$(window).scrollTop(-offsetTop);

		clearPopup();           
	}
	function clearPopup(){
		$('.release-wrapper').find('.map-popup_wrapper').html('');
	}
	function controlHeightDescr(){
		let height = $bigDescr.height();
		$minDescr.css('height', `${height}px`);
	}
	function addOverlay() {
		$('.release-wrapper').append('<div class="map-popup"><a class="videopopup_close js-map-popup-close">Close</a>' +
            '<div class="map-popup_wrapper"></div></div>');
	}
	function setFirstShadow() {
		$(boysIcoClass).eq(0).addClass(boysIcoShadowClass);
	}
	function controlIcoShadow(e) {
		let $currentIco = $(e.currentTarget),
			self = this;

		if (e.type == 'mouseenter') {               
			$currentIco.removeClass(boysIcoShadowClass);
		}
		if (e.type == 'mouseleave') {
			$currentIco.addClass(boysIcoViewedClass);

			$(boysIcoClass).each(function () {
				if (!$(this).parent().find(boysIcoClass).hasClass(boysIcoShadowClass) && !$(this).hasClass(boysIcoViewedClass)) {
                    
					$(this).addClass(boysIcoShadowClass);
					return false;
				}
			});
		}
	}
	function showHiglight(e){
		let $currentIco = $(e.currentTarget),
			currIndex = $currentIco.index() - 2;

		if (e.type == 'mouseenter') {
			$('.js-slider-frame-idw').not('.w-slider_item__outside-right, .w-slider_item__outside-left').find(sliderHighlightClass).eq(currIndex).addClass(sliderHighlightActiveClass);
		}
		if (e.type == 'mouseleave') {
			$(sliderHighlightClass).removeClass(sliderHighlightActiveClass);
		}
	}
	$('.promo-slider__tank-anim').addClass('release-block-anim__faded');

	$('.tab-horizontal').wrap('<div class=\'tab-horizontal_outer\'></div>');

	$(function () {
		showHideElem();
	});
	function  isMobile(){
		let check = false;
		(function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
		return check;
	}

	if(isMobile()){
		$('.release-block_video-wrapp').remove();
	}
	$scrollToButton.on('click', function () {
		$scrollTo.length && $documentRoots.animate({
			scrollTop: $scrollTo.offset().top
		}, 600);
	});

	$('.js-tab-item').on('click', function(){        
		let thisIndex = parseInt($(this).data('tabItem'));

		if(thisIndex == 3 || thisIndex == 2 || thisIndex == 1 || thisIndex == 0){
			$('.awards-section').addClass('awards-section__min');
		}else{
			$('.awards-section').removeClass('awards-section__min');
		}

	});

	function showHideElem() {
		windowHeightIndentDiff = getWindowHeightIndentDiff();

		if (!isElemHidden) {
			return false;
		}

		$animItem.each(function (index) {

			var elementLength = $animItem.length,
				$element = $(this),
				topPosition = $element.offset().top - $(window).scrollTop();
			if (topPosition <= windowHeightIndentDiff) {
				$element.removeClass(animItemClass);
				if (index === elementLength - 1) {
					isElemHidden = false;
				}
			}
		});
	}

	function getWindowHeightIndentDiff() {

		if (window.innerWidth >= 720) {
			bottomIndent = 60;
		} else {
			bottomIndent = 30;
		}

		windowHeightIndentDiff = $(window).height() - bottomIndent;

		return windowHeightIndentDiff;
	}

	$(window).on('scroll', _.throttle(function () {
		if (isElemHidden) {
			showHideElem();
		}
	}, 200));

	$(window).on('resize', _.throttle(function () {
		showHideElem();
	}, 400));
}
